<template>
  <div>
    <div class="row">

      <div class="col-6 mb-3">
        <h1>{{$t('menu.6')}}</h1>
      </div>
      <div class="col-6 mb-3 ">
        <el-button-group class="pull-right">
          <el-tooltip :content="$t('yeni')" placement="bottom">
            <el-button type="success" icon="el-icon-plus" @click="yeni"></el-button>
          </el-tooltip>
        </el-button-group>
      </div>
    </div>

    <span id="jsZaman"></span>


    <div class="card">
      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="veri()"
            style="width: 100%">
            <el-table-column
              :label="$t('kasa.adi')"
              prop="adi">
            </el-table-column>

            <el-table-column
              :label="$t('kasa.aciklama')"
              prop="aciklama">
            </el-table-column>

            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  :placeholder="$t('ara')"/>
              </template>
              <template slot-scope="scope">
                <el-tooltip :content="$t('duzenle')" placement="right">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"><i class="i-Brush"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip :content="$t('sil')" placement="right">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </div>
    </div>

    <el-dialog :title="$t('menu.6')" :visible.sync="modal">

      <el-form :model="KasaForm" status-icon ref="KasaForm">
        <el-form-item
          prop="adi"
          :label="$t('kasa.adi')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('kasa.bos') }]">
          <el-input v-model="KasaForm.adi"></el-input>
        </el-form-item>

        <el-form-item
          prop="aciklama"
          :label="$t('kasa.aciklama')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('kasa.bos') }]">
          <el-input v-model="KasaForm.aciklama"></el-input>
        </el-form-item>

        <el-form-item
          prop="id"
          autocomplete="off"
          type="hidden">
          <el-input type="hidden" :value="this.KasaForm.id"></el-input>
        </el-form-item>




      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modal = false">{{$t('iptal')}}</el-button>
        <el-button type="primary" @click="onSubmit('KasaForm')">{{$t('kaydet')}}</el-button>

      </span>
    </el-dialog>

  </div>
</template>

<script>


    export default {
        data() {
            return {
                Data: [],
                modal: false,
                search: '',
                KasaForm: {
                    id: '',
                    adi: '',
                    aciklama: '',
                },
                yenimodal: false,
                formLabelWidth: '180px',
            }
        },
        methods: {
            veri(){
                if (this.Data!=null){
                    var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
                }else if(this.Data==''){
                    var veri = this.Data;
                }
                return veri
            },
            handleEdit(index, row) {
                this.KasaForm = row
                this.modal = true
            },
            handleDelete(index, row, rows) {
                row.splice(index, 1);

                this.$store.dispatch("dataver", {
                    method: 'delete',
                    url: '/kasa/' + rows.id,
                    data: ''
                }).then(response => {
                    if (response.Status == 'OK') {

                    } else {

                    }
                });


            },
            KasaListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/kasa"})
                    .then(response => {
                        //console.log(response)
                        if (response.Status == 'OK') {
                            this.Data = response.Data;
                        } else {

                        }
                    });
            },
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.yenimodal == false) {

                            this.$store.dispatch("dataver", {
                                method: 'put',
                                url: '/kasa/' + this.KasaForm.id,
                                data: this.KasaForm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.KasaListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }
                        if (this.yenimodal == true) {

                            this.$store.dispatch("dataver", {
                                method: 'post',
                                url: '/kasa/',
                                data: this.KasaForm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.KasaListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }

                    }
                });
            },
            yeni() {
                this.KasaForm = {}
                this.yenimodal = true
                this.modal = true
            },
        },
        created() {
            this.KasaListele()
        }
    }




</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/kasa/index.vue